module.exports = __webpack_public_path__ + "img/mentee-avatar.f1296211.svg";